/*globals jQuery, MS, YT, mscc */
( function ( $ ) {
	'use strict';

	$( document ).ready( function(){

		if( typeof mscc === 'undefined' ){
			return;
		}

		if( mscc && mscc.hasConsent() ){
			return;
		}

		function giveConsent( e ){
			mscc.setConsent();
		}

		$( '#msr-search-form, .msr-events-form' ).each( function () {
			var $self  = $( this );
			var $submit = $self.find( 'input[type="submit"]' );
			var $selects = $self.find( 'select' );

			$selects.on( 'change', giveConsent );
			$submit.on( 'submit', giveConsent );
		} );

		$( '.bi-filter-list' ).on( 'click', 'a', giveConsent );
		$( document.getElementById( 'msr-sort-publications' ) ).on( 'change', giveConsent );
		$( '[role="tab"], .msr-search-sidebar-anchor, .bi-filter-list a, .msr-expandable-section a, .msr-toggle-more-less__trigger, .slide-arrow, .slide-dot, .show-more, .widget_filter_submit, .widget_filter_reset, .video-gallery-trigger' ).on( 'click', giveConsent );
	} );

} )( jQuery );
